export function manageSlider() {
    let sliderParent = $(".manage-slider");
    let thumbSlider = sliderParent.find(".manage-slider-thumbs");
    let pictureSlider = sliderParent.find(".manage-slider-pictures");

    pictureSlider.slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        dots: true,
        asNavFor: $(thumbSlider)[0],
        adaptiveHeight: true,
    });

    thumbSlider.on('init', function(event, slick){
        let slideThumb = thumbSlider.find(".manage-thumb-item");
        slideThumb.each((index, item) => {
            $(item).prepend(`<span class="number">${index + 1}</span>`);
        });
    });
    thumbSlider.slick({
        infinite: false,
        slidesToShow: 1.3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        mobileFirst: true,  
        asNavFor: $(pictureSlider)[0],
        focusOnSelect: true,
        appendArrows: $(sliderParent).find(".manage-slider-thumbs-arrows"),
        responsive: [
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 3.5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    arrows: true,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/manage-slider.js